export const SEND_EMAIL_START = "contactForm/SEND_EMAIL_START";
export const SEND_EMAIL_COMPLETED = "contactForm/SEND_EMAIL_COMPLETED";
export const SEND_EMAIL_FAILED = "contactForm/SEND_EMAIL_FAILED";
export const SET_HAS_BEEN_SENT = "contactForm/SET_HAS_BEEN_SENT";
